import React from 'react';
import PropTypes from 'prop-types';
import { Card, Row, Col } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import Calendar from 'components/common/Calendar';
import { getImageUrlOfConfig } from 'y4/Falcon';

const ArticleDetailHeader = ({ article }) => {
  const d1 = article.date ? new Date(article.date) : new Date();
  const d2 = d1.toDateString().split(' ');
  const d3 = { day: d2[2], month: d2[1] };

  const image = getImageUrlOfConfig(article);

  return (
    <Card className="p-0 mb-3">
      {!!image && <img className="card-img-top" src={image} alt="" />}
      <Card.Body className="overflow-hidden">
        <Row className="flex-center">
          <Col>
            <Flex>
              <Calendar {...d3} />
              <div className="fs--1 ms-2 flex-1">
                <h5 className="fs-0 text-capitalize">{article.title}</h5>
                <p className="mb-0 text-capitalize"> {article.caption}</p>
                <span className="fs-0 text-warning fw-semi-bold">
                  {article.date}
                </span>
              </div>
            </Flex>
          </Col>
          <Col md="auto" className="mt-4 mt-md-0">
            <Flex>
              {/**
              <IconButton
                className="me-2"
                variant="falcon-default"
                size="sm"
                icon="heart"
                iconClassName="text-danger"
              >
                235
              </IconButton>
              <IconButton
                className="me-2"
                variant="falcon-default"
                size="sm"
                icon="share-alt"
              >
                Share
              </IconButton>
               
              <Button
                variant="falcon-primary"
                size="sm"
                className="px-4 px-sm-5"
              >
                Feedback
              </Button>
              */}
            </Flex>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

ArticleDetailHeader.propTypes = {
  article: PropTypes.object
};

export default ArticleDetailHeader;
